<form class="payment-radio-form" [formGroup]="rowAmountSelectionForm" autocomplete="off">
  @if (showBillAccountName) {
    <p class="flex items-center pad-top-10 margin-0">
      <span data-cy="billAccountPaymentName" class="payment-account-name">{{
        paymentAmounts.name
      }}</span>
      @if (allowRemove === true) {
        <a
          data-cy="billAccountPaymentRemove"
          class="block md-inline md-float-right error-600-text caption"
          title="Remove selection"
          alt="Remove selection"
          (click)="onRemoveClick()"
        >
          @if (paymentAmountsCount > 1) {
            <p>
              <span dsContent [contentPath]="'shared.removeSelection'"></span>
            </p>
          }
        </a>
      }
    </p>
  }
  <div [ngClass]="['payment-radio-' + directionFlow]" class="payment-radio-container">
    @if (!!paymentAmounts.pastDuePaymentInfo) {
      @if (!paymentAmounts?.pastDuePaymentInfo?.cancelationLetterSent) {
        <ds-radio-toggle-button
          data-cy="billAccountPaymentPastDueToggle"
          [labelClass]="[
            paymentType === 'pastDue' ? 'active' : 'inactive',
            'payment-radio-selection'
          ]"
          inputId="pastAmountDue-{{ uniqueId }}"
          [inputChecked]="paymentType === 'pastDue'"
          inputValue="paymentAmounts.pastDuePaymentInfo.pastDueAmount"
          [formGroup]="rowAmountSelectionForm"
          [inputFormControlName]="'paymentAmountCtrl'"
          [hasSubMessage]="true"
          (click)="onRadioAmtClick('pastDue')"
        >
          <div toggle class="payment-radio-button-content">
            @if (radioAmount) {
              <p class="b margin-0 fill">
                {{ paymentAmounts.pastDuePaymentInfo.pastDueAmount | currencyUSD }}
              </p>
            }
            <p class="margin-0">
              <i class="caption" dsContent [contentPath]="'billing.pastDue'"></i>
            </p>
          </div>
          <div subMessage class="payment-radio-button-sub-content">
            <p class="b margin-0 fill"><b>Past Due Date:</b></p>
            <p class="margin-0">{{ paymentAmounts.pastDuePaymentInfo.pastDueDate | dateFormat }}</p>
          </div>
        </ds-radio-toggle-button>
      }
      @if (paymentAmounts.pastDuePaymentInfo.currentDueAmount !== 0) {
        <ds-radio-toggle-button
          data-cy="billAccountPaymentPastPlusCurrentToggle"
          [labelClass]="[
            paymentType === 'pastPlusCurrent' ? 'active' : 'inactive',
            'payment-radio-selection'
          ]"
          inputId="pastPlusCurrentAmountDue-{{ uniqueId }}"
          [inputChecked]="paymentType === 'pastPlusCurrent'"
          inputValue="paymentAmounts.pastDuePaymentInfo.pastDueAmount + paymentAmounts.pastDuePaymentInfo.currentDueAmount"
          [formGroup]="rowAmountSelectionForm"
          [inputFormControlName]="'paymentAmountCtrl'"
          [hasSubMessage]="true"
          (click)="onRadioAmtClick('pastPlusCurrent')"
        >
          <div toggle class="payment-radio-button-content">
            @if (radioAmount) {
              <p class="b margin-0 fill">
                {{
                  paymentAmounts.pastDuePaymentInfo.pastDueAmount +
                    paymentAmounts.pastDuePaymentInfo.currentDueAmount | currencyUSD
                }}
              </p>
            }
            <p class="margin-0">
              <i class="caption" dsContent [contentPath]="'billing.pastPlusCurrent'"></i>
            </p>
          </div>
          <div subMessage class="payment-radio-button-sub-content">
            <p class="b margin-0 fill"><b>Past Due + Current Due:</b></p>
            <p class="margin-0">
              {{
                (paymentAmounts.pastDuePaymentInfo.pastDueAmount | currencyUSD) +
                  ' + ' +
                  (paymentAmounts.pastDuePaymentInfo.currentDueAmount | currencyUSD)
              }}
            </p>
            <p class="b margin-0 fill"><b>Due Date:</b></p>
            <p class="margin-0">
              {{
                paymentAmounts.pastDuePaymentInfo.cancelationLetterSent
                  ? 'Today'
                  : (paymentAmounts.pastDuePaymentInfo.currentDueDate | dateFormat)
              }}
            </p>
          </div>
        </ds-radio-toggle-button>
      }
    }

    @if (!paymentAmounts.pastDuePaymentInfo) {
      @if (showZeroAmounts || paymentAmounts.minDue > 0) {
        <ds-radio-toggle-button
          data-cy="billAccountPaymentMinDueToggle"
          [labelClass]="[
            paymentType === 'minAmountDue' ? 'active' : 'inactive',
            'payment-radio-selection'
          ]"
          inputId="minAmountDue-{{ uniqueId }}"
          [inputChecked]="paymentType === 'minAmountDue'"
          inputValue="paymentAmounts.minDue"
          [formGroup]="rowAmountSelectionForm"
          [inputFormControlName]="'paymentAmountCtrl'"
          (click)="onRadioAmtClick('minAmountDue')"
        >
          <div toggle class="payment-radio-button-content">
            @if (radioAmount) {
              <p class="b margin-0 fill">
                {{ paymentAmounts.minDue | currencyUSD }}
              </p>
            }
            <p class="margin-0">
              <i class="caption" dsContent [contentPath]="'billing.minDue'"></i>
            </p>
          </div>
        </ds-radio-toggle-button>
      }
    }

    @if (showZeroAmounts || paymentAmounts.balance > 0) {
      <ds-radio-toggle-button
        data-cy="billAccountPaymentBalanceToggle"
        [labelClass]="[
          paymentType === 'unpaidBalance' ? 'active' : 'inactive',
          'payment-radio-selection'
        ]"
        inputId="unpaidBalance-{{ uniqueId }}"
        [inputChecked]="paymentType === 'unpaidBalance'"
        inputValue="paymentAmounts.balance"
        [formGroup]="rowAmountSelectionForm"
        [inputFormControlName]="'paymentAmountCtrl'"
        (click)="onRadioAmtClick('unpaidBalance')"
      >
        <div toggle class="payment-radio-button-content">
          @if (radioAmount) {
            <p class="b margin-0 fill">
              <b>{{ paymentAmounts.balance | currencyUSD }}</b>
            </p>
          }
          <p class="margin-0">
            @if (!paymentAmounts?.fullPayAvailable) {
              <i class="caption" dsContent [contentPath]="'billing.unpaidBalance'"></i>
            }
            @if (paymentAmounts?.fullPayAvailable) {
              <i class="caption" dsContent [contentPath]="'billing.fullPayBalance'"></i>
            }
          </p>
        </div>
      </ds-radio-toggle-button>
    }

    @if (showOtherAmount) {
      <ds-radio-toggle-button
        data-cy="billAccountPaymentOtherToggle"
        [labelClass]="[
          paymentType === 'otherAmount' ||
          (paymentAmounts.minDue <= 0 && paymentAmounts.balance <= 0)
            ? 'active'
            : 'inactive',
          'payment-radio-selection -with-input'
        ]"
        inputId="otherAmountInput-{{ uniqueId }}"
        [inputChecked]="
          paymentType === 'otherAmount' ||
          (paymentAmounts.minDue <= 0 && paymentAmounts.balance <= 0)
        "
        inputValue="rowAmountSelectionForm.controls['otherAmountCtrl'].value"
        [formGroup]="rowAmountSelectionForm"
        [inputFormControlName]="'paymentAmountCtrl'"
        (keyup)="onOtherAmtClick('otherAmount', $event)"
        (click)="onOtherAmtClick('otherAmount', $event)"
      >
        <div toggle class="row payment-radio-button-input" #radioBoxInput>
          <ds-form-control-container [control]="rowAmountSelectionForm.controls['otherAmountCtrl']">
            <input
              type="tel"
              maxlength="8"
              id="otherAmountInput-{{ uniqueId }}"
              placeholder="Other Amount"
              class="fill margin-top-0"
              formControlName="otherAmountCtrl"
              autocomplete="off"
              data-cy="billAccountPaymentsOtherAmountRadio"
            />
          </ds-form-control-container>
        </div>
      </ds-radio-toggle-button>
    }
  </div>
</form>

@if (amtValidationError) {
  <span class="caption error-600-text">{{ amtValidationError }}</span>
}
